import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class ContratacoesVigentesService extends CRUDService{
    constructor() {
        super("alocacao");
    }

    listarContratacoesVigentes(filtro) {
        return http.post("/"+this.serviceName+"/vigente", filtro)
    }
}